enum UserPreferences {
  PrefersMiniNavbar = "prefersMiniNavbar",
  Mode = "mode",
}
export default UserPreferences;
